import React from 'react';

import { CookieConsent,  Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, BibliotekaOgrodnicza, MuseoPage, Interview, GardenTherapy, Gadziak, PersonProfile, TreePage, Yoga, TherapySessions, TreeInventory, TeamGallery, History, PartnersPage, GalleryPartners, Training, TrainingSingle, Contact, ServiceSingle, ServicePage, LegendPage, LegendSingle, CareerForm, TeamPage, TeamSingle, KolejWaskotorowaPage, KolejWaskotorowaHistoria, KolejWaskotorowaTowarzystwo, KolejWaskotorowaGaleria } from './sections';


import { Routes, Route } from "react-router-dom";
import { CareerSection } from './sections/index';



const App = () => {


  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/O-nas' element={<AboutUs />} />
        <Route path='/Legenda' element={<LegendPage />} />
        <Route path='/Legenda/:id' element={<LegendSingle />} />
        <Route path='/Muzeum' element={<MuseoPage />} /> 
        <Route path='/Historia' element={<History />} />
        <Route path='/RadaNaukowa' element={<TeamPage />} />  
        <Route path='/RadaNaukowa/:id' element={<TeamSingle />} />    
        <Route path='/RadaNaukowa/Galeria' element={<TeamGallery />} />
        <Route path='/Poznaj-nas' element={<PersonProfile />} />

        <Route path='/Biblioteka-Ogrodnicza' element={<BibliotekaOgrodnicza />} />

        {/*Kolej Wąskotorowa*/}
        <Route path='/Kolej-Waskotorowa' element={<KolejWaskotorowaPage />} />
        <Route path='/Kolej-Wąskotorowa' element={<KolejWaskotorowaPage />} />
        <Route path='/Kolej-Waskotorowa/Historia' element={<KolejWaskotorowaHistoria />} />
        <Route path='/Kolej-Wąskotorowa/Historia' element={<KolejWaskotorowaHistoria />} />
        <Route path='/Kolej-Waskotorowa/Towarzystwo' element={<KolejWaskotorowaTowarzystwo />} />
        <Route path='/Kolej-Wąskotorowa/Towarzystwo' element={<KolejWaskotorowaTowarzystwo />} />
        <Route path='/Kolej-Waskotorowa/Galeria' element={<KolejWaskotorowaGaleria />} />
        <Route path='/Kolej-Wąskotorowa/Galeria' element={<KolejWaskotorowaGaleria />} />

        {/*Service*/}
        <Route path='/Uslugi' element={<ServicePage />} />     
        <Route path='/Uslugi/:id' element={<ServiceSingle />} />    
        <Route path='/Uslugi/usluga' element={<ServiceSingle />} /> 

        {/*Partners*/}
        <Route path='/Partnerzy' element={<PartnersPage />} />
       <Route path='/Partnerzy/Galeria' element={<GalleryPartners />} />
       <Route path='/Gadziak' element={<Gadziak/>} />
       <Route path='/Drzewo-Pokolen' element={<TreePage/>} />

        {/* Kariera */}
        <Route path='/Staze' element={<CareerSection />} />
        <Route path='/Staze/Formularz' element={<CareerForm />} />

        {/*Training*/}
        <Route path='/Szkolenie' element={<Training />} />
        <Route path='/Szkolenia/:id' element={<TrainingSingle />} />
 
        {/*Contact*/}
        <Route path='/Skontaktuj-sie' element={<Contact />} /> 

        {/* Psychologia zieleni */}
        <Route path='/Psychologia-zieleni/Wywiad' element={<Interview />} />
        <Route path='/Psychologia-zieleni/Ogrodoterapia' element={<GardenTherapy />} />
        <Route path='/Psychologia-zieleni/Sesje' element={<TherapySessions />} />
        <Route path='/Psychologia-zieleni/Joga' element={<Yoga />} />

        <Route path='/Inwentaryzacja-drzew' element={<TreeInventory />} />

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />

      <CookieConsent />
      
    </div>
  )
}

export default App;
